var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, config, continueBtnText, doneText, hasNarration, hasPrompt, i18n, labelValues, labels, notches, prompt, question, slider, submitUp, undefined) {
buf.push("<div class=\"content-fill\"><div class=\"content-fit content-md-fill content-sm-ver\"><div class=\"content-md-ver text-center block-v-lg\"><h1>" + (null == (jade_interp = question.content) ? "" : jade_interp) + "</h1><div class=\"slider scale-up\"><div class=\"slider-bar\"></div><div class=\"slider-knob slider-knob-input\"><div class=\"slider-knob-value text-md text-nowrap\">" + (jade.escape((jade_interp = i18n("slider.touch-to-slide")) == null ? '' : jade_interp)) + "</div></div><div class=\"slider-knob slider-knob-answer\"><div class=\"slider-knob-value text-md text-nowrap\">" + (null == (jade_interp = slider.prefix) ? "" : jade_interp) + (null == (jade_interp = "") ? "" : jade_interp) + (null == (jade_interp = slider.suffix) ? "" : jade_interp) + "</div></div><div class=\"slider-notches\">");
// iterate (new Array(notches + 1))
;(function(){
  var $$obj = (new Array(notches + 1));
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var notch = $$obj[i];

buf.push("<div" + (jade.attr("style", "left: " + (i / notches * 100) + "%;", true, false)) + " class=\"slider-notch\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var notch = $$obj[i];

buf.push("<div" + (jade.attr("style", "left: " + (i / notches * 100) + "%;", true, false)) + " class=\"slider-notch\"></div>");
    }

  }
}).call(this);

buf.push("</div>");
if ( slider.labels)
{
buf.push("<div class=\"slider-labels\">");
var attr = config.direction === "rtl" ? "right" : "left";
// iterate labelValues
;(function(){
  var $$obj = labelValues;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var label = $$obj[i];

buf.push("<div" + (jade.attr("style", "" + (attr) + ": " + (i / (labels - 1) * 100) + "%;", true, false)) + " class=\"slider-label\">" + (null == (jade_interp = slider.prefix) ? "" : jade_interp) + (null == (jade_interp = slider.decimals ? label.toFixed(slider.decimals) : label) ? "" : jade_interp) + (null == (jade_interp = slider.suffix) ? "" : jade_interp) + "</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var label = $$obj[i];

buf.push("<div" + (jade.attr("style", "" + (attr) + ": " + (i / (labels - 1) * 100) + "%;", true, false)) + " class=\"slider-label\">" + (null == (jade_interp = slider.prefix) ? "" : jade_interp) + (null == (jade_interp = slider.decimals ? label.toFixed(slider.decimals) : label) ? "" : jade_interp) + (null == (jade_interp = slider.suffix) ? "" : jade_interp) + "</div>");
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("<div class=\"slider-label-text\">");
if ( slider.minLabel)
{
buf.push("<div class=\"slider-label-min pull-left\">" + (null == (jade_interp = slider.minLabel) ? "" : jade_interp) + "</div>");
}
if ( slider.maxLabel)
{
buf.push("<div class=\"slider-label-max pull-right\">" + (null == (jade_interp = slider.maxLabel) ? "" : jade_interp) + "</div>");
}
buf.push("</div></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"labelValues" in locals_for_with?locals_for_with.labelValues:typeof labelValues!=="undefined"?labelValues:undefined,"labels" in locals_for_with?locals_for_with.labels:typeof labels!=="undefined"?labels:undefined,"notches" in locals_for_with?locals_for_with.notches:typeof notches!=="undefined"?notches:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"question" in locals_for_with?locals_for_with.question:typeof question!=="undefined"?question:undefined,"slider" in locals_for_with?locals_for_with.slider:typeof slider!=="undefined"?slider:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}